import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles({
  cardTitle: {
    padding: "8px 0"
  },
  typo: {
    fontSize: 16,
    lineHeight: "24px"
  },
});

export default function TitleField({title}) {
  const classes = useStyles();

  return (
    <div className={classes.cardTitle}>
      <Typography className={classes.typo} align="center">
        {title}
      </Typography>
    </div>
  );
};
